export enum CatalogsFilters {
  Search = 'Search',
  Region = 'Region',
  Organization = 'Organization',
  Year = 'Year',
  Crop = 'Crop'
}
